module.exports = __webpack_public_path__ + "img/speedometer.68edc5d6.svg";